// src/components/Recruiter/RecruiterRejected.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const RecruiterRejected = () => {
    return (
        <div className="container mx-auto px-4 py-16 max-w-2xl">
            <div className="bg-white rounded-2xl shadow-lg p-8 text-center">
                <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="fas fa-times-circle text-red-600 text-3xl"></i>
                </div>
                <h1 className="text-2xl font-bold text-gradpath-dark mb-2">Application Not Approved</h1>
                <p className="text-gray-600 mb-4">We appreciate your interest in partnering with GradPath.</p>
                <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6 text-left">
                    <p className="text-sm text-red-800"><i className="fas fa-info-circle mr-2"></i>Your application did not meet our recruiter terms and conditions at this time.</p>
                    <p className="text-sm text-red-800 mt-2"><i className="fas fa-envelope mr-2"></i>Our team has tried to contact you. To re-apply, please email us at: <a href="mailto:recruiters@gradpath.co.za" className="text-gradpath-green font-medium hover:underline ml-1">recruiters@gradpath.co.za</a></p>
                </div>
                <Link to="/" className="px-6 py-2 bg-gradpath-green text-white rounded-lg hover:bg-gradpath-dark transition">Go to Homepage</Link>
            </div>
        </div>
    );
};

export default RecruiterRejected;